import type { CSSProperties } from "react";

import styled, { css } from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";

export const StyledDropZoneAction = styled.span`
    ${setFontVariant("button", colorsPalettes.blue[400])}
`;

export const StyledDropZone = styled.div<{ $isDragActive: boolean; $isDisabled: boolean }>`
    box-sizing: border-box;
    width: 100%;
    background-color: ${colorsPalettes.bluegrey[100]};
    border: 1px dashed ${colorsPalettes.blue[400]};
    border-radius: 5px;
    text-align: center;

    ${({ $isDragActive }) =>
        $isDragActive &&
        css`
            background-color: ${rgba(colorsPalettes.blue[400], 0.08)};
        `}

    ${({ $isDisabled }) =>
        $isDisabled &&
        css`
            pointer-events: none;
            border-color: ${colorsPalettes.carbon[200]};

            ${StyledDropZoneAction} {
                color: ${colorsPalettes.carbon[250]};
            }
        `}
`;

export const StyledDropZoneLabel = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 62px 0;
    cursor: pointer;

    & path {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const StyledHiddenInput = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

export const LOADER_OPTIONS = {
    svg: {
        stroke: colorsPalettes.carbon[250],
        strokeWidth: 2,
        r: 8,
        cx: "50%",
        cy: "50%",
    },
    style: {
        position: "initial" as CSSProperties["position"],
        width: 26,
        height: 26,
    },
};
